import {defineMessages} from 'react-intl';

export default defineMessages({
    platform: {
        defaultMessage: 'Platform',
        description: 'Group for tags that filtering a library by platform',
        id: 'dash.libraryTagGroups.platform'
    },
    category: {
        defaultMessage: 'Category',
        description: 'Group for tags that filtering a library by category',
        id: 'dash.libraryTagGroups.category'
    },
    soundType: {
        defaultMessage: 'Sound Type',
        description: 'Group for tags that filtering a library by sound type',
        id: 'dash.libraryTagGroups.soundType'
    }
});
